import { Helmet } from "react-helmet";
import BreadCrumb from "../components/Breadcrumb";
import classes from "./TermsAndConditions.module.css";
import { Link } from "react-router-dom";

export default function TermsAndConditions() {
  return (
    <>
      <Helmet>
        <title>
          Terms & Conditions - Server Stock UK Online IT Hardware Purchases
        </title>
        <meta
          name="description"
          content="Read the comprehensive Terms & Conditions of Server Stock UK, covering purchase guidelines, responsibilities, and online shopping rules for servers, PCs, and networking products."
        />
        <link
          rel="canonical"
          href="https://www.serverstock.co.uk/terms-and-conditions"
        />
      </Helmet>

      <BreadCrumb currentPage="Terms and Conditions" />
      <div className={`container ${classes.TermsAndConditionsContainer}`}>
        <p className={classes.paragraph}>
          These terms and conditions apply to open online orders and sales.
          Please read them carefully. Note that special terms apply to consumers
          and take precedence over other provisions.
        </p>
        <h2 className={classes.subheading}>1- Website</h2>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            1.1) Welcome to Server Stock! We are resellers of IT hardware,
            software, computer-related products, peripherals, and accessories.
            Our website is designed to benefit our current and prospective
            customers. By placing an order with us, you are agreeing to adhere
            to our terms and conditions. We strongly recommend that you
            thoroughly review these terms before finalizing your order to ensure
            a comprehensive understanding of our policies. We reserve the right
            to modify our terms and conditions at any time without prior notice.
            If you have any concerns or objections regarding our terms and
            conditions, we kindly ask that you refrain from using our website.
            If you have any questions or concerns regarding our terms and
            conditions, please do not hesitate to contact us or send an email to{" "}
            <Link to="mailto:support@serverstock.co.uk">
              support@serverstock.co.uk
            </Link>{" "}
            . Thank you for choosing Server Stock!
          </p>
        </div>
        <h2 className={classes.subheading}>2- Definitions</h2>
        <p className={classes.paragraph}>
          Please find below the updated and corrected definitions of key terms
          used in our business:
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            2.1) “Business Customer:” An entity or organization that purchases
            goods or services for commercial or institutional use rather than
            personal use is considered a Business Customer.
          </p>

          <p className={classes.paragraph}>
            2.2) “Consumer:” A consumer is someone who buys and uses goods or
            services for personal use, not for resale or commercial purposes.
          </p>

          <p className={classes.paragraph}>
            2.3) “Server Stock:” Also referred to as “Server Stock,” “we,” or
            “us” in these Terms and Conditions.
          </p>

          <p className={classes.paragraph}>
            2.4) “Catalog:” The catalog of products and services offered by us.
          </p>

          <p className={classes.paragraph}>
            2.5) “Force Majeure:” Any factor hindering our obligations due to
            events beyond our control, such as government regulations, natural
            disasters, or labor disputes that affect third parties.
          </p>

          <p className={classes.paragraph}>
            2.6) “Working Hours:” 8:00 AM to 5:00 GMT (GMT)on a working day.
          </p>

          <p className={classes.paragraph}>
            2.7) “Working Days:” Monday to Friday, which excludes public or bank
            holidays.
          </p>
          <p className={classes.paragraph}>
            2.8) “Open Online” or “website” The internet website is accessed
            through the address{" "}
            <Link to="https://www.serverstock.co.uk">
              www.serverstock.co.uk
            </Link>{" "}
            .
          </p>
          <p className={classes.paragraph}>
            2.9) “Customer:” A business customer, customer, or potential
            customer of our company.
          </p>

          <p className={classes.paragraph}>
            2.10) “User:” The person who accesses Open Online on behalf of the
            customer.
          </p>

          <p className={classes.paragraph}>
            2.11) “Administrator:” The person in charge of administering and
            authorizing users on behalf of the customer.
          </p>

          <p className={classes.paragraph}>
            2.12) “Products:” The products listed for sale on Open Online, which
            the customer can purchase.
          </p>

          <p className={classes.paragraph}>
            2.13) “Terms and Conditions:” The terms and conditions for access to
            the Open Online system by the customer and its users, and the terms
            and conditions of the limited sale, which deal with the trading and
            commercial aspects between the customer and our company.
          </p>
        </div>
        <h2 className={classes.subheading}>3- Orders</h2>
        <p className={classes.paragraph}>
          These Terms and Conditions apply to all sales purchase products (the
          "Products") to Customer. Upon receipt of an express acceptance by the
          Customer or upon commencement of performance by Seller, the Purchase
          Order and these Terms and Conditions become a binding contract between
          the two parties (the "Sales Agreement"). If there is a conflict in
          terms and conditions and any Purchaser (delivery) Order, these Terms
          and Conditions will prevail unless the Seller has agreed to the terms
          in the Purchase Order. If there is a conflict between the Purchaser's
          Order and the Seller's acceptance or order acknowledgment, the
          acceptance or order acknowledgment will prevail. Nothing in these
          Terms and Conditions is intended to affect a Consumer's statutory or
          contractual rights to reject faulty Products.
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            3.1) All delivery orders are subjected to availability and
            acceptance of the Products ordered. Seller reserves the right to
            refuse any order placed by the Customer.
          </p>

          <p className={classes.paragraph}>
            3.2) The Customer agrees to provide accurate details to the Seller
            to purchase Products or services offered on the website. The
            debit/credit card used to buy must belong to the Customer or their
            company, and they must be authorized to use it. Sufficient funds or
            credit facilities must be available to cover the cost of any
            Products or services ordered. Before providing any Products or
            services, Seller reserves the right to obtain validation of the
            Customer's credit or debit card details.
          </p>

          <p className={classes.paragraph}>
            3.3) Seller may monitor or record inbound or outbound calls and
            electronic traffic for training purposes.
          </p>

          <p className={classes.paragraph}>
            3.4) Order is subjected to be accepted to credit approval and
            approval by the seller. If the Customer's credit becomes
            unsatisfactory to Seller, Server Stock reserves the right to
            terminate the Sales Agreement upon notice to the Customer and
            without liability to Seller.
          </p>
        </div>
        <h2 className={classes.subheading}>4 – Prices:</h2>
        <p className={classes.paragraph}>
          Please find below the revised version of the text with corrected
          grammar, spelling, and punctuation errors for better clarity.
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            4.1) All prices mentioned are exclusive of any applicable sales
            taxes. The customer is responsible for any additional sales taxes in
            their state, province, or country.
          </p>

          <p className={classes.paragraph}>
            4.2) Please ensure that you provide us with the correct email
            address when placing your order. We will use it to send you
            important communications, so it's crucial to double-check that it's
            accurate.
          </p>
        </div>
        <h2 className={classes.subheading}> 5- Ordering:</h2>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            5.1) Once your order has been accepted, we will send you another
            email to confirm.
          </p>

          <p className={classes.paragraph}>
            5.2) After dispatching your order, we will send you yet another
            email with its tracking number.
          </p>

          <p className={classes.paragraph}>
            5.3) Please ensure that you provide us with the correct email
            address when placing your order, either through the website, phone,
            or fax, as we will use it to send you these communications.
          </p>

          <p className={classes.paragraph}>
            5.4) Let us know if you have any questions or concerns..
          </p>
        </div>
        <h2 className={classes.subheading}>6 – Delivery, Title, and Risk</h2>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            6.1) Delivery Questions and Order Status: For any inquiries about
            delivery, please contact our Customer Support team at{" "}
            <Link to="tel:+442475420877">+44 247 542 0877</Link> . To check the
            status of your order, simply login to your account.{" "}
            <Link to="https://serverstock.co.uk">serverstock.co.uk</Link> .
          </p>

          <p className={classes.paragraph}>
            6.2) We make every effort to dispatch your order by the agreed-upon
            date. However, we cannot be held liable for any failure to deliver
            within the stated time if it is caused by circumstances beyond our
            control, such as (delivery company) delays or manufacturer’s lead
            times. If we anticipate a delay, we will contact you to inform you.
            If you are a Consumer and the revised delivery date is not
            acceptable, you are entitled to cancel your order.
          </p>

          <p className={classes.paragraph}>
            6.3) Cancellation and Refund Policy for Business Customers: We offer
            a 30-day return policy, which means you have 30 days after receiving
            your item to request a return. To return an item, it must be in its
            original packaging, unused, with tags, and include the receipt or
            proof of purchase.
          </p>

          <p className={classes.paragraph}>
            6.4) It is important that customers report any shortages or damages
            in writing within 3 days of receiving their order. The report should
            include detailed descriptions of the issue. Once we receive the
            report, we will investigate and, if necessary, arrange for
            replacement or compensation. If the customer fails to report the
            issue within this period, they waive any related claims.
          </p>

          <p className={classes.paragraph}>
            6.5) Business Customers are required to be able to accept the
            Products during Normal Working Hours.
          </p>

          <p className={classes.paragraph}>
            6.6) he risk associated with the Products is transferred to the
            Customer at the moment of their delivery by the Designated Carrier.
            If the customer didn’t dispatch the products to the carrier on the
            given time due to a lack of appropriate instructions, documents, or
            authorizations, then the risk in the products will pass to the
            customer from the moment a signed proof of delivery is obtained. In
            such cases, the Products will be considered delivered and may be
            stored until delivery, for which the Customer will be liable for all
            related costs and expenses.
          </p>

          <p className={classes.paragraph}>
            6.7) Title of the Products will not pass on to the Customer until
            full payment is received.
          </p>
          <p className={classes.paragraph}>
            6.8) If the Customer didn’t accept delivery, the seller may store
            and insure the Products at the Customer's expense and risk or sell
            the items at the best price (reasonably obtainable). After deduction
            of reasonable storage, insurance, and selling costs, the seller can
            pay the consumer any excess over the price (sale price) or charge
            the Consumer for any shortfall. Alternatively, the seller may
            rearrange delivery, for which the Customer may be charged additional
            delivery costs..
          </p>
          <p className={classes.paragraph}>
            6.9) Upon delivery, the Customer must sign a proof of delivery to
            acknowledge safe receipt. The Customer is responsible for ensuring
            that the number of delivered packages corresponds with the stated
            number on the delivery note. In case of any discrepancy or evident
            damage to the packaging, the Customer should note it on the proof of
            delivery without amendment.
          </p>
        </div>
        <h2 className={classes.subheading}>7 – Delivery terms:</h2>
        <p className={classes.paragraph}>
          Here is a clearer version of the text with corrected spelling,
          grammar, and punctuation errors.
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            7.1) Standard Delivery: You will receive a complete delivery within
            3 to 4 business days when all the items/products are in stock.
          </p>

          <p className={classes.paragraph}>
            7.2) Same-Day Delivery: You will receive your order for items that
            are in stock before the close of business on the same day for all
            orders placed.
          </p>

          <p className={classes.paragraph}>
            7.3) Part Shipping: If you order more than one item, they could be
            on different lead times. In this case, you can request deliveries,
            and you will be charged a fee for all the extra item deliveries
            above the standard.
          </p>

          <p className={classes.paragraph}>
            7.4) Shipping to Various Locations: If you buy centrally and you
            wish to have different items delivery to various offices, we can do
            this for you after the relevant security checks are clear and the
            added costs covered.
          </p>
        </div>
        <h2 className={classes.subheading}>8- Availability:</h2>
        <p className={classes.paragraph}>
          We do our best to ensure all the products advertised on our website
          are available, but we cannot guarantee it. You can find accurate
          information on product availability on our website. In case your
          chosen product is unavailable, we will inform you within a reasonable
          time with expected delivery dates. If it remains unavailable, we will
          propose an extension or suggest an alternative. Even if a product is
          indicated as out of stock, there is still a chance that one of our
          trusted sources might have it in stock. You can contact us via phone
          or email us at{" "}
          <Link to="https://serverstock.co.uk">serverstock.co.uk</Link> to
          check.
        </p>
        <h2 className={classes.subheading}>9- Payments:</h2>
        <p className={classes.paragraph}>
          We offer various payment methods, including credit and debit cards
          such as Visa, Mastercard, American Express, and Discover, as well as
          bank transfer websites. We want to assure you that all of our payment
          methods are secure and safe to use. Our website is fully compliant
          with relevant standards, including SSL certifications, to ensure that
          your payment information is protected.
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            <strong>9.1 Payment Methods:</strong>
          </p>
          <ul>
            <li className={classes.list}>Bank Transfer</li>
            <li className={classes.list}>Credit and debit card:</li>
            <li className={classes.list}>
              Visa (Including Visa Electron & Visa Debit)
            </li>

            <li className={classes.list}>Mastercard</li>

            <li className={classes.list}>American Express</li>

            <li className={classes.list}>Discover</li>

            <li className={classes.list}>Stripe</li>

            <li className={classes.list}>PayPal</li>
          </ul>
        </div>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            <strong>9.2 Product Specifications:</strong>
          </p>
          <p className={classes.paragraph}>
            9.2.1 While we consistently endeavor to provide products as
            advertised, we reserve the right to supply them with minor
            variations in actual dimensions and specifications, if the
            manufacturer makes any changes.
          </p>

          <p className={classes.paragraph}>
            9.2.2 If we are unable to supply the products that the customer has
            ordered, we reserve the right to offer products of superior or equal
            quality/specification at no additional cost. In such instances, if
            the consumer chooses not to accept the alternative products offered,
            they may cancel the item order and request a refund for that order,
            including shipping charges. This will be the only option available
            to the customer in such circumstances.
          </p>

          <p className={classes.paragraph}>
            9.2.3 Please ensure that you provide us with the correct email
            address when placing your order, either through the website, phone,
            or fax, as we will use it to send you these communications.
          </p>
        </div>
        <h2 className={classes.subheading}>
          10 – Trade Names and Trade Marks:
        </h2>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            10.1) Please note that the trade names and marks, other than those
            belonging to our company, may not always indicate the actual
            manufacturer of a product. They might rather indicate the general
            use systems and machines associated with such products.
          </p>

          <p className={classes.paragraph}>
            10.2) If you are purchasing a component and require a specific
            brand, we suggest checking the manufacturer's identity for the
            intended component before placing an order. This step will help
            ensure that you receive the product you are seeking.
          </p>

          <p className={classes.paragraph}>
            10.3) Please ensure that you provide us with the correct email
            address when placing your order, either through the website, phone,
            or fax, as we will use it to send you these communications. Let us
            know if you have any questions or concerns.
          </p>
        </div>
        <h2 className={classes.subheading}>11 – Warranties and Returns:</h2>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            11.1) We are dedicated to providing exceptional products and
            services to our valued customers. However, we understand that some
            items may be found to be defective. In those cases, we offer the
            returns facilities that are defined below:
          </p>

          <p className={classes.paragraph}>
            11.2) We guarantee that all products delivered carry a 12-month
            manufacturer's warranty unless otherwise stated in the
            manufacturer's documentation.
          </p>

          <p className={classes.paragraph}>
            11.3) If you purchase products for your business, the following
            provisions of this clause will apply. Apart from the (express
            provisions) set out in the Terms and Conditions, all other
            terms/implied terms or warranties related to the product supply are
            carefully excluded to the extent permitted by law. Our
            products/items are not sold or tested as being fit for any software
            or application or use under specific conditions unless expressly
            agreed in writing.
          </p>

          <p className={classes.paragraph}>
            11.4) If you're buying services for your business, the following
            terms apply. The service provider will use their skills and
            expertise to deliver services to the highest industry standards.
            However, they cannot be held accountable for any damage caused by
            anyone other than their engineers or agents. If there is a dispute
            over the quality of the service, the provider reserves the right to
            appoint an independent expert to assess the work carried out.
            Additionally, they cannot be held responsible for any equipment that
            has been altered or configured by someone else.
          </p>

          <p className={classes.paragraph}>
            11.5)If you have purchased server stock and it is faulty, we offer a
            no-charge collection, repair, and delivery service, but you need to
            report the fault within 7 days of delivery. If the product you
            receive is defective, you must return it within 7 days or within the
            manufacturer's time limit. Note that some manufacturers require
            returns within a shorter time frame. We will only accept the return
            of a defective product if it does not meet the description and is
            returned to us within 7 days. If you do not return the product
            within this time period, you will be deemed to have accepted it, and
            you must promptly check the product upon receipt.
          </p>

          <p className={classes.paragraph}>
            11.6) It is important to note that this warranty is the only
            warranty with respect to the products. There are no other
            warranties, including merchantability warranties (implied) and
            fitness for (any particular) purpose. Furthermore, there are no
            warranties for performance or production, expendable or wearing
            parts, or any other product that is not expressly listed here.
          </p>
        </div>
        <p className={classes.paragraph}>
          If the product you receive is defective, you must return it within 7
          days or within the manufacturer's time limit. Note that some
          manufacturers require returns within a shorter time frame. We will
          only accept the return of a defective product if it does not meet the
          description and is returned to us within 7 days. If you do not return
          the product within this time period, you will be deemed to have
          accepted it, and you must promptly check the product upon receipt. It
          is important to note that this warranty is the only warranty with
          respect to the products. There are no other warranties, including
          merchantability warranties (implied) and fitness for (any particular)
          purpose. Furthermore, there are no warranties for performance or
          production, expendable or wearing parts, or any other product that is
          not expressly listed here.
        </p>
        <h2 className={classes.subheading}>12 – Health and Safety</h2>
        <p className={classes.paragraph}>
          We ensure that the products we supply do not pose a threat to health
          and safety. Please make sure they are used properly for their intended
          purpose and the customer takes reasonable and normal precautions while
          using them.
        </p>
        <h2 className={classes.subheading}>13 – Force Majeure:</h2>
        <p className={classes.paragraph}>
          In the event that circumstances beyond its reasonable control and/or
          Force Majeure prevent it from fulfilling its obligations, despite
          making reasonable efforts, the company shall not be considered to have
          breached its contract with the customer.
        </p>
        <h2 className={classes.subheading}>14 – Errors and Omissions:</h2>
        <p className={classes.paragraph}>
          Although we make every effort to ensure that the prices and
          descriptions quoted in our catalog and on our website are accurate,
          mistakes can still happen due to the fast-paced nature of e-commerce.
          If we discover a manifest error or omission, we reserve the right to
          cancel the order even if we have already received payment or accepted
          the order. However, we will be liable to return any money paid by the
          customer for the order.
        </p>
        <h2 className={classes.subheading}>
          15 – Obligations for the Customer:
        </h2>
        <p className={classes.paragraph}>
          Please find the updated version of the text you shared below, which
          has been made clearer and free of any errors:
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            15.1) The Customer is required to appoint an Open Online
            "Administrator" who is named on the Open Online authorization form.
          </p>

          <p className={classes.paragraph}>
            15.2) The Administrator is responsible for using the Open Online on
            behalf of the Customer.
          </p>

          <p className={classes.paragraph}>
            15.3) The Customer can change the Administrator by either using the
            online facility or by notifying limited in writing of the new
            Administrator's identity.
          </p>

          <p className={classes.paragraph}>
            15.4) The Consumer is responsible for ensuring that they meet all
            requirements (technical) of Open Online access. Limited shall not be
            liable for any losses resulting from technical incompatibilities or
            system errors.
          </p>

          <p className={classes.paragraph}>
            15.5) The Customer must ensure that neither their authorized
            Administrator nor Users share any login details with third parties
            under any circumstances.
          </p>
        </div>
        <h2 className={classes.subheading}>
          16 – Obligations for the Administrator:
        </h2>
        <p className={classes.paragraph}>
          The Administrator has certain obligations that they must fulfill.
          These include authorizing, approving, and setting access for new and
          existing users. They are also responsible for removing, deleting, or
          amending any users who are no longer with the company or who are not
          able to Open Online in place of the consumer for any reason. It is the
          Administrator's responsibility to ensure that all customer company
          details on Open Online are correct, including postal and delivery
          addresses.
        </p>
        <h2 className={classes.subheading}>17 – Obligations of the User:</h2>
        <p className={classes.paragraph}>
          Please make sure to follow the below guidelines while using Open
          Online:
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            17.1) Whenever performing any actions using Open Online, you must
            always act on behalf of the Customer.
          </p>

          <p className={classes.paragraph}>
            17.2) Under no circumstances are you allowed to share any security
            details, such as usernames and passwords, with third parties.
          </p>

          <p className={classes.paragraph}>
            17.3) If you are no longer representing or employed by the Customer,
            you are not permitted to use any login information provided to
            access Open Online.
          </p>
        </div>
        <h2 className={classes.subheading}>18 – Security and Login:</h2>
        <p className={classes.paragraph}>
          Open Online login credentials consist of three elements: The Account
          Number, the User's (unique within the Customer) Username (usually an
          alphanumeric combination, such as the User's email address), and the
          User's secret Password (any alphanumeric combination). Using the login
          information is proof that the Customer consents to orders and
          information placed on their behalf. The Customer, Administrator, and
          User are responsible for ensuring that the login information,
          especially the Password, remains confidential. They should make every
          reasonable effort to keep the information secure.
        </p>
        <h2 className={classes.subheading}>19 – License:</h2>
        <p className={classes.paragraph}>
          You may use this website under these Terms and Conditions for all
          pages. The license granted to you may be terminated at any time by the
          website without notice.
        </p>
        <h2 className={classes.subheading}>20 – Materials on the Website:</h2>
        <p className={classes.paragraph}>
          All the rights to the content on this website, including those in
          copyright, are owned, licensed, or controlled for these purposes by
          the website owner. This includes the website's design, layout,
          appearance, and graphics. You may not use or reproduce the content in
          any way except for your own private, non-commercial use. For any other
          use, you need written permission from the website owner. Do not
          distribute or copy the content on this website for commercial purposes
          without the owner's prior written consent. This includes sharing the
          material with third parties, reproducing, transmitting, or storing it
          in any other website or electronic retrieval system.
        </p>
        <h2 className={classes.subheading}>21 – Website Information:</h2>
        <p className={classes.paragraph}>
          Please note that the information provided on this website is subject
          to change without notice and is given in good faith. However, except
          for the extent expressly provided in the Terms and Conditions, if
          applicable, we cannot be held responsible for any inaccuracies and do
          not make any representation or give (any warranty) as per its
          accuracy.
        </p>
        <h2 className={classes.subheading}>22 – Linking:</h2>
        <p className={classes.paragraph}>
          We accept no responsibility or liability for any content found on
          websites that are not under our strict control (i.e. of other
          websites). Please note that any link to another website should not be
          considered or interpreted as an endorsement of that website unless
          explicitly stated.
        </p>
        <h2 className={classes.subheading}>23 – Liability:</h2>
        <p className={classes.paragraph}>
          Please note the following important information:
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            23.1) Except as expressly provided in the Terms and Conditions, if
            applicable, there is no warranty or representation whatsoever
            regarding the website.
          </p>

          <p className={classes.paragraph}>
            23.2) We cannot guarantee that this website will be compatible with
            all platform, hardware and software used by visitors.
          </p>
        </div>
        <h2 className={classes.subheading}>
          24 – Changes to the Content of the Website:
        </h2>
        <p className={classes.paragraph}>
          The following terms and conditions apply to your use of this website:
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            24.1) The content of this website is subject to change.
          </p>

          <p className={classes.paragraph}>
            24.2) We may change the content of this website at any time without
            notice.
          </p>

          <p className={classes.paragraph}>
            24.3) We may also update these terms and conditions from time to
            time by posting the revised version on this website. In case of any
            substantial changes, we will make reasonable efforts to inform
            visitors. You are advised to check these terms and conditions
            regularly.
          </p>
        </div>
        <h2 className={classes.subheading}>
          25 – Viruses & Malfunctioning Programs:
        </h2>
        <p className={classes.paragraph}>
          The website and its access may contain errors, viruses, bugs, and
          other malicious code.
        </p>
        <h2 className={classes.subheading}>
          26 – User Conduct about our Security & Privacy:
        </h2>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            26.1) You have agreed to follow certain rules while using the
            website. These rules are important to ensure that the website is
            secure, safe, and user-friendly for everyone.
          </p>
          <p className={classes.paragraph}>
            26.2) o You must not disrupt the security of the website or abuse
            any of the services, resources, accounts, servers, or networks that
            are connected to or accessible through the website. You must also
            not interfere with the ability of other users to benefit from the
            website or its affiliated or linked websites. Additionally, you must
            not send unsolicited mass emails or upload any defamatory, obscene,
            or unlawful content to the website that may infringe upon any
            third-party rights or cause offense.
          </p>
          <p className={classes.paragraph}>
            26.3) If you breach any of these obligations mentioned in this
            clause, you will be held accountable. You must indemnify and hold
            harmless for any breach by you of these obligations.
          </p>{" "}
          <p className={classes.paragraph}>
            26.4)As an account holder, you will be given a username and password
            to be able to open your account information on the website. You must
            not share or disclose your username and password with anyone else.
          </p>
          <p className={classes.paragraph}>
            26.5) You must not use the username or password of any other
            account, and you must not allow any other account to use your
            password at any time. If someone suspects that the security of your
            username and password has been breached, you must notify us
            immediately by telephoning the IT Manager or emailing us.
          </p>
        </div>
        <h2 className={classes.subheading}>27 – Group companies</h2>
        <p className={classes.paragraph}>
          We reserve the right to fulfill our obligations and exercise our
          rights under the contract by ourselves or through any other member of
          our group of companies, at our discretion. However, we will still be
          held accountable for the actions or inactions of any other member of
          our group of companies.
        </p>
        <h2 className={classes.subheading}>28 – Repair Service:</h2>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            {" "}
            28.1) We shall not be held liable for any loss of business, actions,
            costs, claims, consequential damages, due to any direct or indirect
            claims made against us or our customers resulting from any kind
            repair we perform.
          </p>
          <p className={classes.paragraph}>
            28.2) We operate on a 'No Fix/No Fee' basis. If we are unable to
            repair the products, we will not charge the customer (excluding
            shipping costs). However, a test report may be charged if requested.
          </p>
          <p className={classes.paragraph}>
            28.3) We assure our customers that we will use all reasonable
            efforts to service or repair the products and/or remedy any faults
            on the product as reported by the customer.
          </p>

          <p className={classes.paragraph}>
            28.4) In cases where a customer has multiple units whose status they
            are not sure of, we offer a test service that does not include any
            repairs. Once the test reports are available, customers can then
            request a quote for the repairs.
          </p>
          <p className={classes.paragraph}>
            28.5) We will quote the cost of the repair with the information
            available to us at the time of the requested quote. If, upon
            inspection of the product, it is not possible to repair it for the
            agreed price, an "uplift" of the repair price may be required to
            continue. If the customer declines the uplift, the unit will be
            returned as "Beyond Economical Repair" at no cost to the customer
            (excluding shipping costs). Customers can request a copy of the test
            results, which can be charged at the rate (test rate) rather than
            the rate (repair rate).
          </p>

          <p className={classes.paragraph}>
            28.6) We reserve the right to declare products as "Beyond Repair."
          </p>

          <p className={classes.paragraph}>
            28.7) Any repair is subject to the availability of necessary parts.
          </p>

          <p className={classes.paragraph}>
            28.8) If products have to be held while waiting for parts or for any
            other reason, we will notify the customer as soon as possible. We
            shall not be held liable for any delays.
          </p>

          <p className={classes.paragraph}>
            28.9) During the inspection stage, if the cost (of any part)
            required to complete an item repair exceeds the repair price, this
            cost may be passed on to the customer in the form of an "uplift" on
            the repair price. In such cases, we will not order the parts until
            we receive confirmation from the customer agreeing to the uplifted
            repair price. If the customer declines the uplift, the products will
            be returned as "Beyond Economical Repair" at no cost to the customer
            (excluding shipping costs). Customers can request a copy of the test
            results, which will be charged at the test rate rather than the
            repair rate.
          </p>

          <p className={classes.paragraph}>
            28.10) Please take note of the following terms and conditions:
          </p>

          <p className={classes.paragraph}>
            28.11) When repairing or providing other services on Products, we
            may use new or reconditioned parts and components. Rest assured that
            the reconditioned parts will meet the same factory specifications as
            new parts and will be their functional equivalent.
          </p>

          <p className={classes.paragraph}>
            28.12) Before shipping the product to us, the Customer is
            responsible for removing or making a backup of any
            data/configuration stored on the Products.
          </p>

          <p className={classes.paragraph}>
            28.13) As part of the normal repair process, we will delete all
            data/configuration from the Products.
          </p>

          <p className={classes.paragraph}>
            28.14) Please be advised that we are not responsible or liable in
            any way, including consequential damages, for any data stored on the
            Products that is lost, deleted, or otherwise inaccessible.
          </p>

          <p className={classes.paragraph}>
            28.15) We do not warrant that the Products are upgraded to the
            "latest" software version due to copyright and licensing issues.
          </p>

          <p className={classes.paragraph}>
            28.16) If there is a licensing cost associated with upgrading or
            downgrading Products due to HDD/software incompatibilities, we will
            contact the Customer for approval.
          </p>

          <p className={classes.paragraph}>
            28.17) It is the Customer’s responsibility to ensure that all
            Products are sent complete with any external or internal memory. If
            items/products are found to be incomplete, the Products will be
            tested with "reference" parts, which will then be removed prior to
            shipment back to the Customer.
          </p>

          <p className={classes.paragraph}>
            28.18) Please note that the warranty will not cover Products found
            to be faulty due to previous missing memory/flash/flash cards.
          </p>

          <p className={classes.paragraph}>
            28.19) Software issues are not covered under warranty and will be
            charged at full repair price.
          </p>

          <p className={classes.paragraph}>
            28.20) To make a warranty claim, customers must submit a written
            report within the specified period.
          </p>

          <p className={classes.paragraph}>
            28.21) To make a warranty claim, the Customer should report it in
            writing within this period, quoting the serial number, using our
            standard RMA procedure.
          </p>
        </div>
        <p className={classes.paragraph}>
          Please keep in mind the following points regarding the repair of your
          products:
        </p>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            {" "}
            28.22) It is essential that your insurance covers the transportation
            of your products from your premises to our repair facility and back.
            We will notify you within 48 hours of any damage to your products
            that occur during transportation.
          </p>
          <p className={classes.paragraph}>
            28.23) If, during the inspection, your products are found to have no
            fault, we will send you a courtesy communication informing you that
            no fault can be found and requesting further information if
            necessary.
          </p>
        </div>
        <h2 className={classes.subheading}>29 – General:</h2>
        <div className={classes.subItems}>
          <p className={classes.paragraph}>
            29.1) These Terms and Conditions do not affect your statutory rights
            as a consumer.
          </p>
          <p className={classes.paragraph}>
            {" "}
            29.2) Any waiver of a breach of this Agreement must be in writing.
            These Terms and Conditions state the entire agreement between the
            parties and supersede any earlier oral or written communications
            regarding the subject matter.
          </p>
          <p className={classes.paragraph}>
            {" "}
            29.3) These Terms and Conditions take precedence over any additional
            terms on any delivery/Purchase Order, confirmation, sales
            acknowledgment, or any other documents issued by the (either) party.
          </p>
          <p className={classes.paragraph}>
            {" "}
            29.4) Any changes to this Agreement must be in writing/signed by an
            authorized official.
          </p>
          <p className={classes.paragraph}>
            29.5) The headings are provided for convenience only and do not
            impact the interpretation of this Agreement.
          </p>
          <p className={classes.paragraph}>
            {" "}
            29.6) Any notices under this Agreement must be in writing and can be
            sent by first class pre-paid post, fax, or email to the party's last
            notified address, fax number, or email address.
          </p>
        </div>
        <p className={classes.paragraph}>
          {" "}
          For any further questions or queries, please contact us via phone or
          email.
        </p>
        <p className={classes.paragraph}>
          {" "}
          <Link to="tel:+442475420877">+44 247 542 0877</Link> or{" "}
          <Link to="mailto:sales@serverstock.co.uk">
            sales@serverstock.co.uk
          </Link>{" "}
        </p>
      </div>
    </>
  );
}
